export const WORKTIME_CLOCK = '/daily_worktime_clock/';
